var testimoniallist = document.querySelector('.testimonial-list');
if(testimoniallist){
    const swiper = new Swiper('.testimonial-list', {
        // Optional parameters
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        noSwiping: true,
        noSwipingClass: 'swiper-slide',
        navigation: {
            nextEl: '.testimonial-button-next',
            prevEl: '.testimonial-button-prev'
        }
    });
}